import { render } from "./PurchaseVue.vue?vue&type=template&id=f9656330"
import script from "./PurchaseVue.vue?vue&type=script&lang=js"
export * from "./PurchaseVue.vue?vue&type=script&lang=js"

import "./PurchaseVue.vue?vue&type=style&index=0&id=f9656330&lang=css"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__